
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface AdvancedTrackingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isEnabling: boolean;
}

export function AdvancedTrackingDialog({
  open,
  onOpenChange,
  onConfirm,
  isEnabling,
}: AdvancedTrackingDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isEnabling ? t('enableAdvancedTracking') : t('disableAdvancedTracking')}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-4">
            {isEnabling ? (
              <>
                <p>{t('advancedTrackingExplanation')}</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>{t('advancedTrackingFeature1')}</li>
                  <li>{t('advancedTrackingFeature2')}</li>
                  <li>{t('advancedTrackingFeature3')}</li>
                </ul>
              </>
            ) : (
              <p>{t('disableAdvancedTrackingWarning')}</p>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('cancel')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {isEnabling ? t('enable') : t('disable')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
